<template>
  <div id="my-main" v-if="user">
    <BankSelection
      v-if="isShowSelectBank"
      :account-selected-bank-code="selectedBankCode"
      @select-bank="selectAccountBank($event)"
    />
    <div v-show="!isShowSelectBank" class="my" v-if="user != null">
      <v-card flat class="my__section-margin my__profile" elevation="18">
        <div class="my__profile__img">
          <img class="b-img" :src="(user.image||user.image_kakao)|image" alt="profile" v-if="(user.image||user.image_kakao)"/>
          <img class="b-img" src="../../assets/images/ic-ic-pro-default.svg" alt="profile" v-else/>
        </div>
        <div class="my__profile__info">
          <table>
            <tr>
              <td class="td-label">이름</td>
              <td class="td-value">{{user.name}}</td>
            </tr>
            <tr>
              <td class="td-label">상점명</td>
              <td class="td-value">{{user.store.name}}</td>
            </tr>
          </table>
        </div>
      </v-card>
      <MyLoanState class="shadow" />
      <BankAccounts class="shadow" :withdraw-bank-code="selectedBankCode" @show-banks="setIsShowSelectBank(true)" />
      <v-card v-ripple @click="signout" class="signout my__section-margin" flat>
        <p>로그아웃</p>
      </v-card>
      <p class="contact my__section-margin">
        <strong>고객센터:</strong>
        <a href="tel:1811-2807">1811-2807</a> |
        <a href="mailto:contact@funda.kr">contact@funda.kr</a>
      </p>
      <div class="section bottom">
        <button
          class="button next-button"
          :disabled="!(isDocumentSubmittable && isPending)"
          @click="$router.push({name:'documents'})"
          type="button"
          v-ripple
        >{{isPending?"서류제출 하기": '서류제출 완료'}}</button>
      </div>
    </div>
  </div>
</template>
<script>
import AuthService from '@/service/auth/AuthService'
import contractService from '@/service/contract/ContractService'
import MyLoanState from './components/MyLoanState'
import BankSelection from './components/BankSelection'
import BankAccounts from './components/BankAccounts'
import HeaderEventBus from '@/eventbus/HeaderEventBus'

function isEmpty(v) {
  return !!(v == null || v.length === 0)
}
export default {
  components: {
    MyLoanState,
    BankAccounts,
    BankSelection
  },
  data() {
    return {
      user: null,
      isPending: false,
      isShowSelectBank: false,
      selectedBankCode: null
    }
  },
  filters: {
    image: function (value) {
      return value.replace(/^(?:https?:)/, '')
    }
  },
  destroyed() {
    this.$store.commit('ui/headerGobackHasEvent', false)
  },
  async created() {
    HeaderEventBus.onGobackButtonClick(_ => {
      this.setIsShowSelectBank(false)
    })
    this.$store.commit('ui/headerTitle', '나의 정보')
    let user = await AuthService.syncProfile()
    if (!user) {
      AuthService.signout()
      return
    }
    this.selectedBankCode = user.withdrawal_account.bank
    this.user = user
    this.isPending = await contractService.isPending()
  },
  methods: {
    setIsShowSelectBank(flag) {
      this.isShowSelectBank = flag
      this.$store.commit('ui/headerTitle', flag === true ? '은행 선택' : '나의 정보')
      this.$store.commit('ui/headerGobackHasEvent', flag)
    },
    selectAccountBank(bankCode) {
      this.selectedBankCode = bankCode
      this.setIsShowSelectBank(false)
    },
    signout() {
      this.$swal.fire({
        html: '<p class="custom-alert__text">로그아웃 하시겠습니까?</p>',
        showCloseButton: false,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: '확인',
        cancelButtonText: '취소',
        customClass: {
          container: 'custom-alert__container',
          popup: 'custom-alert__popup',
          confirmButton: 'custom-alert__confirm-btn',
          cancelButton: 'custom-alert__cancel-btn'
        }
      }).then(result => {
        if (result.value === true) {
          AuthService.signout()
          this.$router.push({ path: 'signout' })
        }
      })
    }
  },
  computed: {
    isDocumentSubmittable() {
      let user = AuthService.getProfile()
      let result = false
      if (user) {
        let accountNames = ['withdrawal', 'collection', 'repayment']
        result = accountNames.every(name => {
          let account = user[name + '_account']
          return !isEmpty(account.account_number)
        })
      }
      return result
    }
  }
}
</script>
<style lang="scss" scoped>
$gray-font-color: #727d8c;
.shadow {
  /*box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.12);*/
  box-shadow: 0 8px 18px 0 rgba(32, 35, 36, 0.08) !important;
}

#my-main {
  height: calc(100vh - 60px);
  .my {
    width: 100%;
    height: calc(100% - 68px);
    overflow: auto;

    padding-top: 14px;
    &__section-margin {
      margin: 0 25px;
    }
    &__profile {
      min-height: 60px;
      margin-bottom: 31px;
      &__img {
        float: left;
        img {
          width: 52px;
          height: 52px;
          resize: both;
          border-radius: 50%;
        }
      }
      &__info {
        font-size: 14px;
        width: calc(100% - 52px);
        float: left;
        table {
          padding-left: 26px;
          border-spacing: 0 6px;
          td {
            padding: 0;
            min-width: 50px;
          }
          .td-label {
            color: #8a94a2;
            font-weight: 700;
          }
          .td-value {
            font-weight: 900;
          }
        }
      }
    }
    .signout {
      padding: 15px 0;
      text-align: center;
      border-radius: 24px;
      border: 1px solid #d7e1ea;
      color: $gray-font-color;
      font-size: 16px;
      font-weight: 900;
      margin-bottom: 20px;
    }
    .contact {
      margin-bottom: 96px;
      color: $gray-font-color;
      line-height: 24px;
      text-align: center;
      a {
        color: inherit;
        text-decoration: none;
      }
      strong {
        font-weight: 700;
      }
    }
  }
}

@media screen and (min-width: 323px) {
  .contact {
    font-size: 14px;
  }
}
@media screen and (min-width: 304px) and (max-width: 322px) {
  .contact {
    font-size: 13px;
  }
}
@media screen and (min-width: 285px) and (max-width: 303px) {
  .contact {
    font-size: 12px;
  }
}
@media screen and (max-width: 284px) {
  .contact {
    font-size: 11px;
  }
}
</style>
